module.exports = __webpack_public_path__ + "static/media/UserFeedExample.c78df862.png";